var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialsinuseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.632,
    height: 139.73,
    viewBox: "0 0 165.632 139.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6806",
    x: 68.536,
    y: 53.414,
    width: 97.096,
    height: 86.316,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credentials_in_use_icon",
    "data-name": "Credentials in use icon",
    transform: "translate(77.536 59.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40606",
    "data-name": "Path 40606",
    d: "M33.868,9.316H15.741v6.937H26.908a33.994,33.994,0,0,1,6.96-6.937",
    transform: "translate(-34.249 -33.795)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40607",
    "data-name": "Path 40607",
    d: "M23.695,44.629a33.508,33.508,0,0,1,1.7-32.872l-9.652-.008V50.284a33.894,33.894,0,0,1,7.954-5.655",
    transform: "translate(-34.249 -27.104)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40608",
    "data-name": "Path 40608",
    d: "M56.6,85.129V0H0V93.521H51.315A33.718,33.718,0,0,1,56.6,85.129M23.524,69.469H10.89V56.831H23.524Zm0-21.75H10.89V35.085H23.524Zm0-21.75H10.89V13.309H23.524ZM45.371,69.491H32.737V56.854H45.371Zm0-21.75H32.737V35.107H45.371ZM32.737,13.309H45.371V25.991H32.737Z",
    transform: "translate(-77.536 -59.414)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40609",
    "data-name": "Path 40609",
    d: "M59.2,29.331A19.462,19.462,0,1,1,39.74,9.869,19.464,19.464,0,0,1,59.2,29.331",
    transform: "translate(-21.774 -32.274)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40610",
    "data-name": "Path 40610",
    d: "M67.8,20.944a23.214,23.214,0,0,1-27.341,0C28.867,26.127,19.627,37.7,15.349,52.369c-1.174,4.028,1.2,8.31,4.564,8.31H88.361c3.364,0,5.745-4.283,4.564-8.31C88.642,37.7,79.4,26.115,67.811,20.944",
    transform: "translate(-36.162 -1.817)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -77.54, -59.41)",
    filter: "url(#Path_6806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6806-2",
    "data-name": "Path 6806",
    d: "M41.893,1.347l36.826,62.88a2.718,2.718,0,0,1-2.345,4.091H2.722A2.718,2.718,0,0,1,.377,64.227L37.2,1.347a2.718,2.718,0,0,1,4.691,0",
    transform: "translate(77.54 59.41)",
    fill: "#eed202"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M550.944,667.528a2.961,2.961,0,1,1-2.961-2.961,2.961,2.961,0,0,1,2.961,2.961",
    transform: "translate(-508.526 -615.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M527.228,302.387h-.044a1.972,1.972,0,0,1-1.958-1.738L522.8,280.325a1.972,1.972,0,0,1,1.958-2.206h4.949a1.972,1.972,0,0,1,1.958,2.211l-2.48,20.324a1.972,1.972,0,0,1-1.957,1.733",
    transform: "translate(-487.78 -254.851)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsinuseicon);
export default __webpack_public_path__ + "static/media/Credentials in use icon.55157a2fdf5a09beff5757ff5c09f78d.svg";
export { ForwardRef as ReactComponent };